import { apiPost, rawApiFetch } from '../utils/fetch_utils';
import lumiEnvironment from '../../lumi.environment';
import gql from 'graphql-tag';
import { useGraphMutation, GraphQLResponse } from '../utils/graphql_utils';

export const companyLookup = async (
  key: string,
  { companyNumber }: { companyNumber: string },
) => {
  const response = await apiPost(
    `${lumiEnvironment.API_URL}/companies/lookup`,
    { company_number: companyNumber },
  );
  if (!response.success) throw new Error(response.error);
  return response;
};

/**
 * A function to check the role of an account
 */
export const checkEmail = async ({ email }: any) => {
  const response = await apiPost(`/accounts/check-email`, { email });
  if (!(response && response.success)) {
    throw new Error(response?.error);
  }
  return response;
};

export const authenticateAction = async (args: {
  email: string;
  password: string;
  role: string;
}) => {
  const { email, password, role } = args;
  const result = await rawApiFetch(`/accounts/authenticate`, {
    method: 'post',
    body: { email, password, role },
  });
  if (!result.success) throw new Error(result.error);
  return result;
};

type LogoutResponse = GraphQLResponse<{
  logout: {
    success: boolean;
  };
}>;

export const useLogoutMutation = (
  onSuccess: () => void,
  onError?: () => void,
) =>
  useGraphMutation<LogoutResponse>(
    gql`
      mutation Logout {
        logout {
          success
        }
      }
    `,
    {
      throwOnError: true,
      onSuccess,
      onError,
    },
  );

type BanklinkArgs = {
  referenceId: string;
  redirectUrl: string;
  type: string;
  requestExportSelection: boolean;
};

export const getLinkGqlQuery = gql`
  mutation (
    $requestExportSelection: Boolean
    $redirectUrl: String
    $type: String!
    $referenceId: String!
  ) {
    newLink(
      request_export_selection: $requestExportSelection
      redirect_url: $redirectUrl
      type: $type
      reference: $referenceId
    ) {
      url
    }
  }
`;
